<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3vbQNw/tc-custom/9781788630368.jpg?1704537868087" alt="This image is the cover for the book Return to the Field, Rosie Ewing Spy Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return to the Field, Rosie Ewing Spy Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>In this stunning adventure set in war-torn France—a British agent finds herself in Nazi territory—and unsure about who to trust . . .</b><br/>  <br/> It’s the spring of 1944 and Rosie Ewing is returning to German-occupied France, by air, this time.<br/>  <br/> She’s carrying a radio, half a million francs, a pistol, and two cyanide capsules to Finistere in north-west Brittany.<br/><br/> With D-Day looming, Rosie fears that the man who’ll be meeting her on the ground tonight may be a traitor. She can’t be certain. But she does know that the likely end of the road for captured female agents is Ravensbrück, or <i>l’enfer des femmes</i>, as the Resistance calls it—the dreaded concentration camp for women . . .<br/><br/><b>Praise for the Rosie Ewing Spy Thrillers:</b><br/>  <br/> “The most meticulously researched war novels I’ve ever read.” —Len Deighton<br/>  <br/> “His action passages are superb.” —<i>The Observer</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander Fullerton
      </h2>
      
      <p class="authorDescription body article"><P>Alexander Fullerton was a bestselling author of British naval fiction, whose writing career spanned over fifty years. He served with distinction as gunnery and torpedo officer of HM Submarine <I>Seadog</I> during World War Two. He was a fluent Russian speaker, and after the war served in Germany as the Royal Navy liaison with the Red Army. He died in 2008.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61bac840